// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DOCS = '/docs';
export const ROOTS_PCB = '/dashboard';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics')
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    roles: path(ROOTS_DASHBOARD, '/user/roles'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, '/user/edit/:id'),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  client: {
    root: path(ROOTS_DASHBOARD, '/client'),
    profile: path(ROOTS_DASHBOARD, '/client/profile'),
    cards: path(ROOTS_DASHBOARD, '/client/cards'),
    list: path(ROOTS_DASHBOARD, '/client/list'),
    newUser: path(ROOTS_DASHBOARD, '/client/new'),
    editById: path(ROOTS_DASHBOARD, '/client/edit/:id'),
    account: path(ROOTS_DASHBOARD, '/client/account')
  },
  projects: {
    root: path(ROOTS_DASHBOARD, '/projects'),
    shop: path(ROOTS_DASHBOARD, '/projects/shop'),
    product: path(ROOTS_DASHBOARD, '/projects/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/projects/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/projects/list'),
    modules: path(ROOTS_DASHBOARD, '/projects/modules'),
    newProduct: path(ROOTS_DASHBOARD, '/projects/product/new'),
    editById: path(ROOTS_DASHBOARD, '/projects/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/projects/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/projects/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/portfolio-review-is-this-portfolio-too-creative'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  },
  tickets: {
    root: path(ROOTS_DASHBOARD, '/ticket'),
    addticket: path(ROOTS_DASHBOARD, '/ticket/add-tickets'),
    viewticket: path(ROOTS_DASHBOARD, '/ticket/view'),
    activitylog: path(ROOTS_DASHBOARD, '/ticket/view/activity-log'),
    surveyThankYou: path(ROOTS_DASHBOARD, '/ticket/survey/thank-you'),
  },
  testcases: path(ROOTS_DASHBOARD, '/test-cases'),
  hawkowl: path(ROOTS_DASHBOARD, '/hawkowl'),
  testscenarios: path(ROOTS_DASHBOARD, '/test-scenarios'),
  settings: path(ROOTS_DASHBOARD, '/settings'),
  performance: path(ROOTS_DASHBOARD, '/performance'),
};

export const PATH_DOCS = {
  root: ROOTS_DOCS,
  introduction: path(ROOTS_DOCS, '/introduction'),
  quickstart: path(ROOTS_DOCS, '/quick-start'),
  package: path(ROOTS_DOCS, '/package'),

  // Theme UI
  color: path(ROOTS_DOCS, '/color'),
  typography: path(ROOTS_DOCS, '/typography'),
  icon: path(ROOTS_DOCS, '/icon'),
  shadows: path(ROOTS_DOCS, '/shadows'),
  components: path(ROOTS_DOCS, '/components'),
  settings: path(ROOTS_DOCS, '/settings'),
  tips: path(ROOTS_DOCS, '/tips'),

  // Development
  routing: path(ROOTS_DOCS, '/routing'),
  environmentVariables: path(ROOTS_DOCS, '/environment-variables'),
  stateManagement: path(ROOTS_DOCS, '/state-management'),
  apiCalls: path(ROOTS_DOCS, '/api-calls'),
  analytics: path(ROOTS_DOCS, '/analytics'),
  authentication: path(ROOTS_DOCS, '/authentication'),
  multiLanguage: path(ROOTS_DOCS, '/multi-language'),
  lazyload: path(ROOTS_DOCS, '/lazyload-image'),
  formHelper: path(ROOTS_DOCS, '/form-helper'),

  // Changelog
  support: path(ROOTS_DOCS, '/support'),
  changelog: path(ROOTS_DOCS, '/changelog')
};
